module.exports = require("solid-auth-client");